import { Link } from "react-router-dom";
import Seo from "@/components/site/Seo";

export default function NotFound() {
  return (
    <>
      <Seo path="/404" title="Pagina non trovata | STUDIO WEB NS" description="La pagina richiesta non esiste o è stata spostata." noindex />
      <section className="wrap flex min-h-[60vh] flex-col items-start justify-center py-24">
        <p className="eyebrow">Errore 404</p>
        <h1 data-testid="not-found-title" className="mt-4 text-4xl font-extrabold sm:text-5xl">Questa pagina non esiste.</h1>
        <p className="lead-text mt-4 max-w-lg">Forse è stata spostata o il link non è corretto. Puoi ripartire da qui:</p>
        <div className="mt-8 flex flex-wrap gap-3">
          <Link to="/" className="btn-primary">Torna alla home</Link>
          <Link to="/servizi" className="btn-ghost">Servizi</Link>
          <Link to="/prezzi" className="btn-ghost">Prezzi</Link>
        </div>
      </section>
    </>
  );
}
